// Add your custom JS here.
import { Fancybox } from "@fancyapps/ui";
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    floatingLabel();
    console.log('test');

    // Try to get the spliderman
    let elem = document.querySelector('.splide.spliderman');
    if (elem) {
        var splide = new Splide('.splide.spliderman', {
            type: 'loop',
            padding: '1rem',
            gap: '17px',
            focus: 'center',
            breakpoints: {
                640: {
                    padding: '0px',
                    gap: '1.5rem',
                },
            }
        }).mount();
    }



    let modal = document.getElementById('video-modal');
    let iframe = modal.querySelector('iframe');
    // let attrib = iframe.getAttribute('src');
    // let urlsrc = new URL(attrib);

    // if (modal) {

    //     modal.addEventListener('show.bs.modal', () => {
    //         urlsrc.searchParams.set('autoplay', 'true');
    //         iframe.setAttribute('src', urlsrc.toString());
    //     })

    //     modal.addEventListener('hidden.bs.modal', () => {
    //         urlsrc.searchParams.set('autoplay', 'false');
    //         iframe.setAttribute('src', '');
    //     })
    // }

    // Fancybox binder
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

});

const floatingLabel = () => {
    let $floatingLabel = document.querySelectorAll('.floating-label');


    $floatingLabel.forEach(formContainer => {

        let $label = formContainer.querySelector('label');
        let $input = formContainer.querySelector('input');

        $input.addEventListener('focus', function () {
            if (!$label.classList.contains('active')) {
                $label.classList.add('active');
            }
        });

        $input.addEventListener('blur', function () {
            if ($label.classList.contains('active')) {
                $label.classList.remove('active');
            }
        })

    });
}
